import { isWithinInterval, parseISO } from 'date-fns';
import { DateRangeFilterYear } from 'lib/apiClient';

interface GetMonthsCalendarProps {
	years: Array<DateRangeFilterYear>;
	criteriaDateRanges?: Array<string>;
}

interface GetMonthDisabledState {
	dateRange: string;
	isMonthDisabled: boolean;
	criteriaDateRanges?: Array<string>;
}

export const getMonthsCalendar = ({ years, criteriaDateRanges = [] }: GetMonthsCalendarProps): Array<DateRangeFilterYear> => {
	if (criteriaDateRanges.length === 0) {
		return years;
	}

	return years.map((year) => ({
		...year,
		months: year.months.map((month) => ({
			...month,
			isDisabled: getMonthDisabledState({ dateRange: month.dateRange, isMonthDisabled: month.isDisabled, criteriaDateRanges }),
		})),
	}));
};

const getMonthDisabledState = ({ dateRange, isMonthDisabled, criteriaDateRanges = [] }: GetMonthDisabledState) => {
	const [startDate, endDate] = dateRange.split('~');
	const outerRangeStart = parseISO(startDate);
	const outerRangeEnd = parseISO(endDate);

	const isValidDate = criteriaDateRanges.some((val) => {
		const [criteriaStartDate, criteriaEndDate] = val.split('~');
		const innerRangeStart = parseISO(criteriaStartDate);
		const innerRangeEnd = parseISO(criteriaEndDate);

		return (
			isWithinInterval(outerRangeStart, { start: innerRangeStart, end: innerRangeEnd }) ||
			isWithinInterval(outerRangeEnd, { start: innerRangeStart, end: innerRangeEnd })
		);
	});

	return isMonthDisabled || !isValidDate;
};
